// Web-Push subscription helpers for the installed PWA.
import api from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const b64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(b64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
}

export async function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    typeof Notification !== "undefined"
  );
}

export async function currentSubscription() {
  if (!(await pushSupported())) return null;
  try {
    const reg = await navigator.serviceWorker.ready;
    return await reg.pushManager.getSubscription();
  } catch (_) {
    return null;
  }
}

export async function subscribePush() {
  if (!(await pushSupported())) throw new Error("Web Push not supported in this browser.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error(`Permission ${perm}`);

  const { data } = await api.get("/notifications/push/vapid-public-key");
  if (!data.enabled || !data.public_key) {
    throw new Error("Web Push disabled on server (missing VAPID key).");
  }

  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  await api.post("/notifications/push/subscribe", { subscription: sub.toJSON() });
  return sub;
}

export async function unsubscribePush() {
  const sub = await currentSubscription();
  if (!sub) return true;
  try {
    await api.post("/notifications/push/unsubscribe", { endpoint: sub.endpoint });
  } catch (err) {
    // Best-effort — local unsubscribe still runs below.
    if (process.env.NODE_ENV !== "production") console.debug("[push] unsubscribe server call failed:", err?.message);
  }
  return sub.unsubscribe();
}
